module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA4CAQAAAARWLNhAAAAjUlEQVR4Ae3YAQYEMQwF0BxljhAS9Ag9ao5VQAG9QXZZWygF+Qb+fBiQR1TwRaQ9HjYtizM92vMbvywx8fUlPCxx8ZC9HEym/H+l9ttz3wIIECCgXYflGR3aa4Bz/CbgAHxFfEVQgABv0T06tBecijsBB+Ar4jMlQIC3iLcIBxAgQABeSMErNXgpCK81P/KGyc0ejkTyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_record.png
// module id = KT6l
// module chunks = 8